"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveCardRequest = void 0;
var ActiveCardRequest = /** @class */ (function () {
    function ActiveCardRequest() {
    }
    return ActiveCardRequest;
}());
exports.ActiveCardRequest = ActiveCardRequest;
;
//# sourceMappingURL=activeCard.request.js.map